import React from 'react';
import './style.css';
import fingerPrintImage from '../../assets/fingerabdruck_256.jpeg';

export class Footer extends React.Component {
    render() {
        return (
            <div id="footer-screen">
                {/* <div className="footer-container">
                    <div className="footer-divider"></div>
                    <div className="footer-content-container">HIER FINDET IHR IN ZUKUNFT DIE AGENDA UND WEITERE INFORMATIONEN ZU UNSERER HOCHZEIT :) </div>
                    <div className="footer-divider"></div>
                </div> */}
                <div className="greetings-container">
                    <div className="greetings-content-container">Wir freuen uns auf euch!</div>
                    <div className="greetings-content-contact">- Jenni & Patrick -</div>
                    <img alt="Herz" src={fingerPrintImage} className="fingerprint-image" />
                </div>
            </div>
        );
    }
}
